<div class="eui-card-footer-container">
    <mat-card-actions *ngIf="actionButtons || actionIcons || actionMenu" class="eui-card-footer-actions">
        <ng-content *ngIf="actionButtons" select="eui-card-footer-action-buttons"></ng-content>
        <div *ngIf="actionIcons || actionMenu" class="eui-card-footer-actions__icons-container">
            <ng-content *ngIf="actionIcons" select="eui-card-footer-action-icons"></ng-content>
            <ng-content *ngIf="actionMenu" select="eui-card-footer-menu-content"></ng-content>
        </div>
    </mat-card-actions>
</div>
